import { NewFilter } from '@/types/NewFilter';
export const filters: NewFilter[] = [
	{
		key: 'seniorityLevels',
		name: 'Nível',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'companies',
		name: 'Empresa',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'boards',
		name: 'Diretoria',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'managements',
		name: 'Gerência',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'workStations',
		name: 'Local de Trabalho',
		isMulti: true,
		isDisabled: () => false,
	},
];
